// extracted by mini-css-extract-plugin
module.exports = {"tour-badge":"c6e8ba5398--tour-badge--3fUPx"};